<template>
  <div class="post.post-repost">
    <post-header :post="post"/>
    <post-body :text="post.text"/>
  </div>
  <!--.post.post-repost
    post-header(:post="post")
    post-body(:text="post.text")-->
</template>

<script>
import PostHeader from './postHeader.vue';
import PostBody from './postBody.vue';
import Post from './post.vue';

export default {
  name: 'postRepost',
  components: { Post, PostBody, PostHeader },
  props: {
    post: {
      type: Object,
      default() {
        return {};
      },
    },
  },
};
</script>

<style lang="stylus">
.post-repost
  padding 1em 0 0 1em
  border-left 3px solid #ccc
  & .post-header__user-icon
    width 3em
    height 3em
</style>
